var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIconModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close-circle",
    transform: "translate(-1.25 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M1.25,16.25a15,15,0,1,1,15,15A15.013,15.013,0,0,1,1.25,16.25Zm2.093,0A12.907,12.907,0,1,0,16.25,3.343,12.922,12.922,0,0,0,3.343,16.25Z",
    transform: "translate(0 0)",
    fill: "#ccc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M8.749,18.846a1.134,1.134,0,0,1,0-1.593l8.5-8.5a1.126,1.126,0,0,1,1.593,1.593l-8.5,8.5a1.09,1.09,0,0,1-.8.331A1.115,1.115,0,0,1,8.749,18.846Z",
    transform: "translate(2.452 2.453)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M17.253,18.846l-8.5-8.5a1.126,1.126,0,0,1,1.593-1.593l8.5,8.5a1.134,1.134,0,0,1,0,1.593,1.124,1.124,0,0,1-1.593,0Z",
    transform: "translate(2.452 2.453)",
    fill: "#ccc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconModal);
export default __webpack_public_path__ + "static/media/closeIconModal.1095706915c40f9c8fb0014cfebfec02.svg";
export { ForwardRef as ReactComponent };